import { getShowtimeById } from './get-showtime-by-id';
export const getShowtimesByIds = (showtimeIds) => {
    const showtimes = showtimeIds.map(id => getShowtimeById(id));
    return showtimes.filter(showtime => showtime !== undefined);
};
//# sourceMappingURL=get-showtimes-by-ids.js.map